export default "__VITE_ASSET__2f74cde2__"